import * as React from 'react';

const SvgIconMinus = (props) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M6.04997 12.7503C5.83747 12.7503 5.65103 12.6701 5.49063 12.5096C5.33021 12.3492 5.25 12.1626 5.25 11.95C5.25 11.7374 5.33021 11.551 5.49063 11.3908C5.65103 11.2305 5.83747 11.1504 6.04997 11.1504H17.95C18.1625 11.1504 18.3489 11.2306 18.5094 11.3911C18.6698 11.5516 18.75 11.7381 18.75 11.9507C18.75 12.1633 18.6698 12.3497 18.5094 12.51C18.3489 12.6702 18.1625 12.7503 17.95 12.7503H6.04997Z" />
  </svg>
);

export default SvgIconMinus;
